"use strict";

import angular from "angular";

const name = "infinityScrollLoad";
const factory = [
    "$document",
    "$timeout",
    function ($document, $timeout) {
        return {
            restrict: "A",
            scope: {
                loadMore: "=",
                offset: "=",
                timing: "="
            },
            link: function ($scope, $element, $attr) {
                const checkDocumentInitialization = () => {
                    if ($element[0] && $element[0]["SimpleBar"]) {
                        $element[0]["SimpleBar"]
                            .getScrollElement()
                            .addEventListener("scroll", () => {
                                if (
                                    $element[0]["SimpleBar"].contentEl
                                        .scrollHeight -
                                        $scope.offset <=
                                    $element[0]["SimpleBar"].contentEl
                                        .offsetHeight +
                                        $element[0]["SimpleBar"].contentEl
                                            .scrollTop
                                ) {
                                    if ($scope.loadMore) $scope.loadMore();
                                }
                            });
                    } else {
                        setTimeout(() => {
                            checkDocumentInitialization();
                        }, 1000);
                    }
                };
                checkDocumentInitialization();
            }
        };
    }
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
